import './config/apiInterceptor';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';
import './index.css';
import './styles/globals.css';
import App from './App';
import analytics from './services/analytics';

// Initialize product analytics as early as possible so anonymous landing-to-signup
// traffic is captured before identify() fires on login.
analytics.init();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
